//Jonas
const apiPassword = 'iw1bMKCDggi%djqniA*@p83mOCY9MY*tU';
const baseUrl = 'https://sawary.totvspaulista.io:8443/webhook/10cbc8b0-1c17-48a9-b5d5-2c036fd6777b/api/';

//Shopify original
//  const apiPassword = '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';
// const baseUrl = '/admin/api/';

// const baseUrl = 'https://ricambi.agencia2bdigital.com';

async function verifyClient(email) {
    try {
        const response = await fetch(`${baseUrl}2023-04/customers/search.json?query=email:${email}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'apikey': apiPassword
            }
        });

        const data = await response.json();       

        if (data?.customers?.length > 0) {
            return true;
        }      

        return false;
    } catch (error) {
        console.error('Error:', error);
        return false;
    }
}

function isValidPassword(password) {

    if (password.length < 8) {
        return false;
    }


    const hasUpperCase = /[A-Z]/.test(password);
    if (!hasUpperCase) {
        return false;
    }


    const hasLowerCase = /[a-z]/.test(password);
    if (!hasLowerCase) {
        return false;
    }


    const hasNumber = /\d/.test(password);
    if (!hasNumber) {
        return false;
    }


    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    if (!hasSpecialChar) {
        return false;
    }


    return true;
}

function formatCNPJ(cnpjField) {
    const cnpj = cnpjField.value.replace(/\D/g, '');

    if (cnpj.length <= 2) {
        cnpjField.value = cnpj;
    } else if (cnpj.length <= 5) {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2)}`;
    } else if (cnpj.length <= 8) {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5)}`;
    } else if (cnpj.length <= 12) {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8)}`;
    } else {
        cnpjField.value = `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(5, 8)}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`;
    }
}

function formatPhoneSend(phoneField) {
    if (!phoneField) return;
    let cleaned = phoneField?.value.replace(/[^\d]/g, '');
    let formatted = '+55.' + cleaned;

    return formatted;
}

function formatPhone(phoneField) {
    if (!phoneField) return;
    const phone = phoneField.value.replace(/\D/g, '');

    if (phone.length > 2 && phone[2] === '9') {
        phoneField.maxLength = 15; 
    } else {
        phoneField.maxLength = 14; 
    }

    if (phone.length <= 2) {
        phoneField.value = `(${phone}`;
    } else if (phone.length <= 6) {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2)}`;
    } else if (phone.length <= 10) {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
    } else if (phone[2] === '9' && phone.length <= 11) {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`;
    } else {
        phoneField.value = `(${phone.slice(0, 2)}) ${phone.slice(2, 6)}-${phone.slice(6)}`;
    }
}

function displayMessage(message, type) {
    const messageDiv = document.getElementById('message');
    messageDiv.textContent = message;
    messageDiv.style.color = type === 'error' ? 'red' : '#333';
    messageDiv.style.padding = '15px';
}

function togglePasswordVisibility(inputId, iconElement) {
    const passwordInput = document.getElementById(inputId);

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
    } else {
        passwordInput.type = 'password';
    }
}

document.getElementById('cep')?.addEventListener('input', function (e) {
    console.log('nao foi');
    
    let cep = e.target.value.replace(/\D/g, ''); 

    cep = cep.substring(0, 8); 

    if (cep.length > 5) {
        cep = cep.replace(/(\d{5})(\d{0,3})/, '$1-$2'); 
    }

    e.target.value = cep;
});


function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj.length !== 14) return false;

  
  if (/^(\d)\1+$/.test(cnpj)) return false;
  
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}
